module.exports = __webpack_public_path__ + "img/03.d1e4b717.jpg";